export default __webpack_public_path__ + "static/media/generalmills.17c60836.png";